<template>
    <q-dialog v-model="display">
        <q-card>
            <q-card-section>
                <div class="text-h6">{{$t('calculator.transfer_time')}}</div>
            </q-card-section>

            <q-card-section class="q-pt-none">
                <div v-html="$t('calculator.transfer_time_disclaimer')"></div>
            </q-card-section>

            <q-card-actions align="right" class="bg-white text-primary">
                <q-btn flat :label="$t('ok')" v-close-popup />
            </q-card-actions>
        </q-card>
    </q-dialog>
</template>
<script>

export default {
    name: "DisclaimerDialog",
    model: {
        prop: 'show',
        event: 'change'
    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        display: {
            get: function() {
                return this.show
            },
            set: function(value) {
                this.$emit('change', value)
            }
        }
    },
    data() {
        return {
            msg: 'Disclaimer'
        }
    },
    methods: {},
    created() {
    },
    mounted() {
    },
    watch: {},
    components: {},
}
</script>
<style>

</style>
